import { BoxGeometry, PlaneGeometry, CylinderGeometry } from "three";

export const DEFAULT_PLANE_GEOMETRY = new BoxGeometry(1, 0.05, 1);
export const DEFAULT_TILE_TEMPLATE_GEOMETRY = new PlaneGeometry(1, 1);
export const DEFAULT_CYLINDER_GEOMETRY = new CylinderGeometry(0.3, 0.3, 0.6, 16);
